import { render, staticRenderFns } from "./Course-submitter.vue?vue&type=template&id=dd87a7da"
import script from "./Course-submitter.vue?vue&type=script&lang=js"
export * from "./Course-submitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports